import { NgModule } from '@angular/core';
import { CHECKOUT_BASE_CMS_COMPONENTS, CHECKOUT_FEATURE } from '@spartacus/checkout/base/root';
import { CmsConfig, provideConfig, provideConfigFactory } from '@spartacus/core';
import { defaultB2BCheckoutConfig } from './configs/default-b2b-checkout-config';
import { defaultCheckoutB2BRoutingConfig } from './configs/default-checkout-b2b-routing-config';
import { CheckoutB2BEventModule } from '@spartacus/checkout/b2b/root';

export const CHECKOUT_B2B_CMS_COMPONENTS: string[] = [
  /**
   *  TODO:#9574 - we should be able to remove the spread of `CHECKOUT_BASE_CMS_COMPONENTS`.
   * Re-test the B2B checkout flow after doing it.
   */
  ...CHECKOUT_BASE_CMS_COMPONENTS,
  'CheckoutCostCenterComponent',
  'CheckoutPaymentType',
];

export function defaultCheckoutComponentsConfig() {
  const config: CmsConfig = {
    featureModules: {
      [CHECKOUT_FEATURE]: {
        cmsComponents: CHECKOUT_B2B_CMS_COMPONENTS,
      },
    },
  };
  return config;
}

@NgModule({
  imports: [CheckoutB2BEventModule],
  providers: [
    provideConfig(defaultB2BCheckoutConfig),
    provideConfig(defaultCheckoutB2BRoutingConfig),
    provideConfigFactory(defaultCheckoutComponentsConfig),
  ],
})
export class CheckoutB2BRootModule {}
